var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import query from 'syf-component-library/const/mediaQueries';
import Stack from 'syf-component-library/ui/spacing/Stack';
import useMediaQuery from '../../../../hooks/use-media-query';
import useTranslation from '../../../../hooks/use-translation';
import { StyledBorder, StyledText } from '../../../subcomponents';
import { StyledDisclosure, StyledPhoneNumber } from '../../subcomponents';
var Disclosure = function () {
    var i18n = useTranslation();
    var isMobile = useMediaQuery(query.lessThanSmall);
    return (_jsxs(StyledDisclosure, __assign({ mobile: isMobile, direction: "column" }, { children: [_jsx(Stack, { size: "xlarge" }), _jsxs(StyledText, __assign({ size: "root" }, { children: [i18n('settlement.reviewDisclosureSubheading'), "\u00A0", _jsx(StyledPhoneNumber, __assign({ as: "span", weight: "bold", color: "cyanBlue" }, { children: "800-292-7508" })), "."] })), _jsx(Stack, { size: "large" }), _jsx(StyledText, __assign({ size: "root" }, { children: i18n('settlement.reviewDisclosureText') })), _jsx(Stack, { size: "xlarge" }), _jsx(StyledText, __assign({ size: "medium", weight: "light" }, { children: i18n('settlement.reviewCreditHeading') })), _jsx(Stack, { size: "medium" }), _jsx(StyledBorder, {}), _jsx(Stack, { size: "medium" }), _jsx(StyledText, __assign({ size: "root" }, { children: i18n('settlement.reviewCreditText') })), _jsx(Stack, { size: "large" })] })));
};
export default Disclosure;
//# sourceMappingURL=index.js.map